import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { apiGet, apiPut } from '../../api/client';

export default function AdminPages() {
  const [activeTab, setActiveTab] = useState('about');
  const [aboutJson, setAboutJson] = useState('');
  const [streamJson, setStreamJson] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    Promise.all([apiGet('/pages/about'), apiGet('/pages/stream')])
      .then(([about, stream]) => {
        setAboutJson(JSON.stringify(about.content, null, 2));
        setStreamJson(JSON.stringify(stream.content, null, 2));
      })
      .catch(console.error);
  }, []);

  const saveActive = async () => {
    setMessage('');
    try {
      if (activeTab === 'about') {
        const content = JSON.parse(aboutJson);
        await apiPut('/pages/about', { title: 'About ZeMaxi', content });
        setMessage('About page saved.');
      } else {
        const content = JSON.parse(streamJson);
        await apiPut('/pages/stream', { title: 'Live Stream', content });
        setMessage('Stream landing page saved.');
      }
    } catch (err) {
      setMessage(err.message);
    }
  };

  const activeJson = activeTab === 'about' ? aboutJson : streamJson;
  const setActiveJson = activeTab === 'about' ? setAboutJson : setStreamJson;
  const previewPath = activeTab === 'about' ? '/about' : '/stream';

  return (
    <div className="admin-panel-page">
      <div className="admin-panel-toolbar">
        <div className="admin-panel-toolbar-row">
          <div className="admin-panel-tabs">
            <button
              type="button"
              className={`admin-panel-tab ${activeTab === 'about' ? 'active' : ''}`}
              onClick={() => { setActiveTab('about'); setMessage(''); }}
            >
              About
            </button>
            <button
              type="button"
              className={`admin-panel-tab ${activeTab === 'stream' ? 'active' : ''}`}
              onClick={() => { setActiveTab('stream'); setMessage(''); }}
            >
              Stream Landing
            </button>
          </div>
          <div className="admin-panel-toolbar-actions">
            <a href={previewPath} target="_blank" rel="noopener noreferrer" className="btn btn-secondary">
              <i className="fas fa-external-link-alt" aria-hidden="true" /> Preview
            </a>
            <button type="button" className="btn btn-primary" onClick={saveActive}>
              Save {activeTab === 'about' ? 'About' : 'Stream Landing'}
            </button>
          </div>
        </div>
      </div>

      {activeTab === 'stream' && (
        <div className="admin-notice-banner">
          <p>
            Schedule, Stream Info, Setup, and custom pages (e.g. Memes) are edited in{' '}
            <Link to="/admin/stream-pages">Stream Pages</Link>.
            Game calendar entries are managed in <Link to="/admin/schedule">Schedule Games</Link>.
          </p>
        </div>
      )}

      <div className="admin-json-panel">
        <div className="admin-json-panel-head">
          <h3>{activeTab === 'about' ? 'About page content' : 'Stream landing content (/stream)'}</h3>
          <span className="admin-pill is-muted">JSON</span>
        </div>
        <p style={{ margin: '0 0 0.5rem', fontSize: '0.82rem', color: '#8b9cb3' }}>
          {activeTab === 'about'
            ? 'Edit hero text, story, and skills. Invalid JSON will fail on save.'
            : 'Edit hero subtitle, offline message, and platform links only. Invalid JSON will fail on save.'}
        </p>
        {message && <p className="admin-message">{message}</p>}
        <textarea
          className="admin-json"
          value={activeJson}
          onChange={(e) => setActiveJson(e.target.value)}
          rows={24}
          spellCheck={false}
        />
      </div>
    </div>
  );
}
